var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallRainbow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -128 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M450.77 255.988H323.105c0-37.054-30.046-67.105-67.105-67.105s-67.105 30.05-67.105 67.105H61.23c0-107.558 87.2-194.77 194.77-194.77s194.77 87.212 194.77 194.77zm0 0",
    fill: "#ffbc36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 255.988h-61.23c0-107.558-87.2-194.77-194.77-194.77S61.23 148.43 61.23 255.989H0C0 114.61 114.621 0 256 0s256 114.61 256 255.988zm0 0",
    fill: "#fc5162"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M385.203 255.988h-62.098c0-37.054-30.046-67.105-67.105-67.105s-67.105 30.05-67.105 67.105h-62.098c0-71.355 57.844-129.203 129.203-129.203 71.355 0 129.203 57.848 129.203 129.203zm0 0",
    fill: "#65b1fc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256 0h-.035v61.223c.012 0 .023-.004.035-.004 107.57 0 194.77 87.21 194.77 194.77H512C512 114.608 397.379 0 256 0zm0 0",
    fill: "#fc5162"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256 61.219c-.012 0-.023.004-.035.004v127.664c.012 0 .023-.004.035-.004 37.059 0 67.105 30.05 67.105 67.105H450.77c0-107.558-87.2-194.77-194.77-194.77zm0 0",
    fill: "#ffbc36"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256.11 126.785c-.048 0-.098.004-.145.004v62.094h.039c37.058.062 67.055 30.164 66.992 67.219l62.098.105c.12-71.36-57.63-129.3-128.985-129.422zm0 0",
    fill: "#65b1fc"
  })));
}

export default SvgSmallRainbow;